"use client";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { zustandStore } from "../zustand-store";

const TawkMessengerReact = dynamic(
  () => import("@tawk.to/tawk-messenger-react"),
  { ssr: false },
);

declare global {
  interface Window {
    Tawk_API?: {
      hideWidget: () => void;
      showWidget: () => void;
      onLoad: () => void;
    };
  }
}

export default function ChatWidget() {
  const pathname = usePathname();
  const { data } = zustandStore();
  const { isProcessingProgressVisible } = data;

  const shouldHideChatWidget =
    pathname === "/dashboard/edit" ||
    pathname === "/dashboard/report-builder" ||
    pathname === "/dashboard/form-builder" ||
    isProcessingProgressVisible;

  const updateWidgetVisibility = () => {
    if (window?.Tawk_API) {
      if (shouldHideChatWidget) {
        window.Tawk_API.hideWidget();
      } else {
        window.Tawk_API.showWidget();
      }
    }
  };

  useEffect(() => {
    // Set up the onLoad callback when component mounts
    const setupTawkAPI = () => {
      if (window?.Tawk_API) {
        if (window && window.Tawk_API) {
          window.Tawk_API.onLoad = updateWidgetVisibility;
        }
      } else {
        // If Tawk_API is not yet available, try again after a short delay
        setTimeout(setupTawkAPI, 100);
      }
    };

    setupTawkAPI();
  }, []);

  useEffect(() => {
    updateWidgetVisibility();
  }, [pathname, shouldHideChatWidget, isProcessingProgressVisible]);

  return (
    <TawkMessengerReact
      propertyId={"67aeec6c825083258e14f7bf"}
      widgetId={"1ik1kn25i"}
    />
  );
}
